import apiClient from "../../../../services/apiClient";

import address_dictionary from '../data/addresses.json'

import { createArrBuildAndCorpus } from '../helpers/address';

import { sendFileAsBinaryPOST } from '../../../../services/saveFile';



export async function postAnketa(data, files){
    //    cert: child.birthCertificate.files,
    //    ben: benefits.files,
    //    preferences: preferences.files

    const save_anketa = await apiClient.post('requests', data);

    if(!save_anketa.data) return;

    const { _id } = save_anketa.data;

    //const _id = "68caf8d063db2000352811d4";

    const res_save_files = [];

    for(const part in files){
        
        if(!files[part]) continue;

        for(const file of files[part]){
            res_save_files.push(await sendFileAsBinaryPOST({_id, file, typedoc: "request", part}))
        }
    }


    return res_save_files;
}


export async function updateAnketa(id, data) {
    try {
        const response = await apiClient.put(`requests/${id}/main_info`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating application:', error);
        throw error;
    }
}


export async function deleteFile(requestId, fileId, section) {
    try {
        const response = await apiClient.delete(`requests/${requestId}/file/${fileId}/${section}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting file:', error);
        throw error;
    }
}


export async function uploadFiles(requestId, files) {
    try {
        const res_save_files = [];

        for(const part in files){
            
            if(!files[part]) continue;

            for(const file of files[part]){
                res_save_files.push(await sendFileAsBinaryPOST({_id: requestId, file, typedoc: "request", part}))
            }
        }

        return res_save_files;
    } catch (error) {
        console.error('Error uploading files:', error);
        throw error;
    }
}

export async function findKgInfo(search){

    const prep_row = (row)=>{ const { _id, name, number, contacts } = row; return ({ _id, name: `${number} ${name}, ${contacts.address.string}`})};

    const url = `/find_kgs?find_by=name&find_by=number&returns_f=name&returns_f=number&returns_f=contacts.address.string&returns_f=contacts.address.district&search=${search}`
    
    const data = await apiClient.get(url);

    const pr_data = data.data && data.data.map(r=>prep_row(r)) || [];
    
    return  pr_data;

};


async function findAddress(body){

    const url = 'address_find';

    const data = await apiClient.post(url, body);

    return data.data && data.data.data || null;

}

export async function find_districts({search, id}){

    const body = ({ search, id, by: "districts"});

    //return address_dictionary.disctricts;

    const ret = await findAddress(body);

    return ret && ret.districtsByLocality.map(r=>({_id: r.id, name: r.name.fullName})) || null;

}

export async function find_streets({ search, id}){

    const body = ({ search, id, by: "streets"});

    //return address_dictionary.street;

    const ret = await findAddress(body);

    return ret && ret.streetsByDistrict.map(r=>({_id: r.id, name: [r.name.fullName, r.name.shortToponym].join(" ") })) || null;

}

export async function find_buildings({ search, id}){

    const body = ({ search, id, by: "building"});

    //return address_dictionary.realbuildings;

    const ret = await findAddress(body);


    const data = ret && ret.aosByStreet || null;

    return createArrBuildAndCorpus(data);

}